import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CaseService } from '../../services/case.service';
import { DictionaryService } from '../../services/dictionary.service';
import { UtilitiesService} from '../../services/utilities.service';
import { ApplicationPropertyDto } from './dto/application-property.dto';
// import {InputMaskModule} from 'primeng/inputmask';
import { MessageService, Message } from 'primeng/api';
import * as theGlobals from 'src/app/shared/globals';


@Component({
  selector: 'app-case-property',
  templateUrl: './case-property.component.html'
})
export class CasePropertyComponent implements OnInit {

  @Input() caseId: string;
  @Input() myProp: ApplicationPropertyDto;
  @Output() changeEvent = new EventEmitter();

  myProperty: any; // ApplicationPropertyDto;
  propTypeList: [];
  securedTypeList: [];
  cityList: string[];

  allowAPNLookup: boolean;
  useCodeList: any[];

  constructor(private caseService: CaseService, private utilService: UtilitiesService, private dictService: DictionaryService,
              private messageService: MessageService) { }

  ngOnInit() {

    this.myProperty = new ApplicationPropertyDto().create();
    // this.myProperty = this.myProp;
    // this.utilService.doAudit(this.myProp, 'property object in child component');
    // get dictionary fields to populate dropdowns...
    const dicts = this.dictService.getDictionaries(); // get all dictionaries
    // this.utilService.doAudit(dicts, 'dictionaries');
    this.propTypeList = dicts.propertyTypes;
    this.securedTypeList = dicts.securedTypes;
    this.cityList = dicts.cityChoices;
    //
    this.useCodeList = [];
    this.dictService.getCaseDictionaries('usecode').subscribe(data => {
      this.utilService.doAudit(data, 'UseCodes:');
      if (data) {
        this.useCodeList = data;
      }
    });
    this.allowAPNLookup = theGlobals.allowAPNLookup;
    if (this.caseId) {
      this.caseService.getCaseProperty(this.caseId).subscribe(data => {
        this.utilService.doAudit(data, 'property data in child component:');
        this.myProperty = data;
        if (this.myProperty.city) {
          // find matching city from the city list...
          this.myProperty.city = this.getAppealsCity(this.myProperty.city);
        }
      });
    }
  }

  // this method executed whenever any data in the component is changed; it should trigger an event defined on the PARENT component
  dataChange() {
    this.utilService.doAudit(this.myProperty, 'property data changed');
    this.changeEvent.emit(this.myProperty);
  }
  findAPN() {
    let apn = this.myProperty.apn;
    apn = apn.replace(/\s|-/g,'');  // strip out the dashes
    if (apn == "") {
      this.showToast({ key: 'toast', severity: 'info', detail: 'Please enter an APN!', summary: 'Info' });
      return;
    }
    const curYear = new Date().getFullYear();
    let rollYear = this.myProperty.rollYear;
    if (rollYear) {
      let temp = rollYear.split('/');
      rollYear = Number(temp[0]).toString();
    } else {
      rollYear = curYear.toString();
    }
    this.utilService.doAudit(apn + '/' + rollYear, 'APN/Year:');
    this.caseService.findAPN(apn, rollYear).subscribe(response => {
      this.utilService.doAudit(response, 'response:');
      if (response.length > 0) {
        //
        this.myProperty.strNum = response[0].streetNum;
        if (response[0].streetFract) {this.myProperty.strNum = this.myProperty.strNum + response[0].streetFract; }
        let xStreet = response[0].streetName;
        if (response[0].streetDirect) {xStreet = response[0].streetDirect + ' ' + xStreet; }
        if (response[0].streetSuffix) {xStreet = xStreet + ' ' + response[0].streetSuffix; }
        this.myProperty.street = xStreet;
        this.myProperty.taxRateArea = response[0].tra;
        this.myProperty.city = this.getAppealsCity(response[0].city);
        this.myProperty.useCode = this.getUseCodeTranslation(response[0].useCode);

      } else {
        this.showToast({ key: 'toast', severity: 'info', detail: 'No matching APN found!', summary: 'Info' });
      }
    });
  }
  getAppealsCity(appealsCity: string): string {
    // try to find a matching City from the dictionary (independent of case)
    this.utilService.doAudit(this.cityList, 'converting city: ' + this.myProperty.city + ' from list:');
    const matchCity = this.cityList.filter(city => {
      return city.toLowerCase() === appealsCity.toLowerCase() ? city : null;
    });
    this.utilService.doAudit(matchCity, 'Matched Cities');
    if (matchCity.length > 0) {
      this.utilService.doAudit('converted city; from: ' + this.myProperty.city + ' to: ' + matchCity[0]);
      return matchCity[0];
    } else {
      return appealsCity; // return the original (unmatched!) city
    }
  }
  getUseCodeTranslation(xCode: string): string {
    if (xCode === undefined) { return '';}
    if (xCode === null || xCode === '') { return ''; }

    let xCode2 = xCode.slice(0, 2);
    const matchCode = this.useCodeList.filter(item => {
      return item.code == xCode2 ? item : null;
    });
    if (matchCode.length > 0) {
      return matchCode[0].description;
    } else {
      return xCode;
    }
  }
  getUseCodeTranslationOLD(xCode) {
    if (xCode === undefined) { return '';}
    if (xCode === null || xCode === '') { return ''; }

    let xCode2 = xCode.slice(0, 2);
    this.dictService.getUseCodeTrans(xCode2).subscribe(data => {
      if (data) {
        return data;
      } else {
        return '';
      }
    });
  }
  // Toaster/Message-related methods
  showToast(msg: Message) {
    this.messageService.clear('toast');
    this.messageService.add(msg);
  }

  showInfo(myMsg: Message) {
    this.messageService.clear('info');
    this.messageService.add(myMsg);
  }

  clearAll() {
    this.messageService.clear();
  }

}
